const insertTimeValue = (el, value) => {
  el.innerHTML = String(value).padStart(2, '0');
};

const getNextMahurat = timestamp => {
  let intervals = [7423, 52000, 10800, 84220];
  let timestamps = [];

  for (let i = 0, len = intervals.length; i < len; i++) {
    let interval = intervals[i] * 1000;
    let x = (timestamp / interval) >> 0;
    let nextTimestamp = (x + 1) * interval;
    timestamps.push(nextTimestamp);
  }

  return Math.min.apply(Math, timestamps);
};

let nextMahurat = parseInt(getNextMahurat(new Date().getTime()) / 1000);
const secEl = document.getElementById('sec');
const minEl = document.getElementById('min');
const hourEl = document.getElementById('hour');

const displayShubhMahuratMsg = () => {
  document.querySelector('#mahurat-notif').classList.remove('hidden');

  setTimeout(() => {
    document.querySelector('#mahurat-notif').classList.add('hidden');
    nextMahurat = parseInt(getNextMahurat(new Date().getTime()) / 1000);
    runCountDown(parseInt(new Date().getTime() / 1000));
  }, 1000 * 60);
};

const runCountDown = now => {
  document.querySelector('#countdown').classList.remove('hidden');
  const mahuratCountdown = setInterval(() => {
    if (nextMahurat > now) {
      let secondsLeft = nextMahurat - now;
      const hoursLeft = parseInt(secondsLeft / 3600);
      secondsLeft -= hoursLeft * 3600;
      const minsLeft = parseInt(secondsLeft / 60);
      secondsLeft -= minsLeft * 60;

      insertTimeValue(hourEl, hoursLeft);
      insertTimeValue(minEl, minsLeft);
      insertTimeValue(secEl, parseInt(secondsLeft));
      now += 1;
    } else {
      clearInterval(mahuratCountdown);
      document.querySelector('#countdown').classList.add('hidden');
      displayShubhMahuratMsg();
    }
  }, 1000);
};

const currentTime = parseInt(new Date().getTime() / 1000);
nextMahurat > currentTime
  ? runCountDown(currentTime)
  : displayShubhMahuratMsg();
